import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IDetails_Response } from '@shared/constants/models.const';
import { LinksSectionComponent } from '@shared/components/links-section/links-section.component';
import { E_CONTENT_TYPE, E_FOLDER_TYPES } from '@shared/constants/enums.const';

@Component({
  selector: 'app-default-portlets',
  imports: [
    LinksSectionComponent,
  ],
  templateUrl: './default-portlets.component.html',
  styleUrl: './default-portlets.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultPortletsComponent {
  hasPublication = input<boolean>(true);
  hasNews = input<boolean>(true);
  pageData = input<IDetails_Response | any>();

  showDiscussions = computed(() => {
    return this.pageData()?.type !== E_FOLDER_TYPES.Folder && this.pageData()?.folderType !== E_FOLDER_TYPES.Project;
  });

  protected readonly E_CONTENT_TYPE = E_CONTENT_TYPE;
  protected readonly E_FOLDER_TYPES = E_FOLDER_TYPES;
}
